<template>
    <div>
        <div class="columns">
            <div class="column is-6">
                <div class="control has-icons-left">
                    <input v-model="search" class="input" type="text" placeholder="Search...">
                    <span class="icon is-small is-left">
                        <i class="fa fa-search"></i>
                    </span>            
                </div>
            </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}} 
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                    <th v-if="pivot">Schools</th>
                    <th v-if="actions">Actions</th>        
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" @click="show(item.id)">
                    <td>{{item.id}}</td>
                    <td>{{item.name}}</td>
                    <td v-bind:style="{'backgroundColor': item.color}" style="border: 3px solid black"><span>{{item.color}}</span></td>
                    <td v-bind:style="{'backgroundColor': item.text_color}" style="border: 3px solid black"><span>{{item.text_color}}</span></td>
                    <td>{{item.order}}</td>
<!--                    <td>{{item.universal ? 'All schools' : 'Specific'}}</td>-->
                    <td v-if="item.schools"> {{ Array.prototype.map.call(item.schools, function(item) { return item.name; }).join(",") }}</td>
                    <td v-else>All schools</td>
                    <td v-if="pivot && item.pivot && item.pivot.color">
                        <div class="color-box" v-bind:style="{'backgroundColor': item.pivot.color}">

                        </div>
                    </td>
                    <td v-if="pivot && item.pivot && item.pivot.text_color">
                        <div class="color-box" v-bind:style="{'backgroundColor': item.pivot.text_color}">

                        </div>
                    </td>
                    <td v-if="actions" width="10%">
                        <router-link v-bind:to="{ name: 'premade-category', params: { id: item.id }}" class="button tooltip" data-tooltip="View">
                            <span class="icon">
                                <i class="fa fa-eye"></i>
                            </span>
                        </router-link>

                        <router-link @click.native.stop="" v-bind:to="{ name: 'premade-category-edit', params: { id: item.id }}" class="button is-warning tooltip" data-tooltip="Edit">
                            <span class="icon">
                                <i class="fa fa-edit"></i>
                            </span>
                        </router-link>

                        <button class="button is-danger tooltip" data-tooltip="Delete" @click="showDeleteModal($event, item.id, index)">
                            <span class="icon">
                                <i class="fa fa-trash"></i>
                            </span>
                        </button>                                
                    </td>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'premade-categories-table',
  props: {
	items: { required: true },
    page: { required: true },
    total: { required: false, default: 0 },
    actions: {required: false, default: false},
    pivot: {required: false, default: false}
  },
  components: {},
  data() {
        return {
            search: '',
            column: 'id',
            columns: [
                {
                    name: '#',
                    key: 'id'
                },
                {
                    name: 'Name',
                    key: 'name'
                },
                {
                    name: 'Color',
                    key: 'color'
                },
                {
                    name: 'Text Color',
                    key: 'text_color'
                },
                {
                    name: 'Order',
                    key: 'order'
                },
                {
                    name: 'Schools',
                    key: 'universal'
                },
            ],
            reverse: true,
        }
  },
  created(){        
  },
  methods: {
    sortBy(column) {    
    
        if(column != ''){
            if(this.column == column){
              this.reverse = !this.reverse;
            }
            else{
              this.column = column;
            }

            let direction = this.reverse ? "asc" : "desc";

            this.$emit("sort", this.column + "," + direction);
        }
    },   
    onPageChanged(page){
        this.$emit("pageChanged", page);
    },    
    show(id){
        this.$router.push('/dashboard/premade-categories/' + id);
    },
    showDeleteModal(event, id, index){
        event.stopPropagation();
        let self = this;
        this.$swal({
            title: 'Are you sure?',
            text: "This will delete this premade category permanently!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3273dc',
            cancelButtonColor: '#ff3860',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                self.deletePremadeCategory(id, index);
            }
        }).catch((result) => {
        });

    },
      deletePremadeCategory (id, index) {
        this.premadeCategoryRepo.delete(id).then(response => {
            this.items.splice(index, 1);
            this.$swal(
                'Deleted!',
                'Premade category has been deleted.',
                'success'
            )
        });
    }
  },
  watch: {
      'search': _.debounce(function(value){
        this.$emit("search", value);
      }, 800) 
  },
  computed: {
  }  
}
</script>

<style lang="css" scoped>

    .color-box{
        width: 21px;
        height: 21px;
        border-radius: 5px;
        border: 1px solid #ccc;
    }
</style>


// WEBPACK FOOTER //
// src/components/premade-categories/Table.vue